import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Requires login and verified email (or admin). Does not run payment onboarding gate.
 */
export const VerifiedUserRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const user = localStorage.getItem('user');
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  try {
    const u = JSON.parse(user) as { emailVerified?: boolean; isAdmin?: boolean };
    if (u.isAdmin || u.emailVerified !== false) {
      return <>{children}</>;
    }
    return <Navigate to="/verify-email" replace />;
  } catch {
    return <Navigate to="/login" replace />;
  }
};
